import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Product Planning & Design",
      desc: "I help my clients define actionable roadmaps for building their product. I am known for creating the most beautiful and intuitive user interfaces across multiple platforms.",
      icon: "fas fa-palette",
    },
    {
      name: "MVP Development",
      desc: "I always consider the bigger picture while scoping the minimum requirements for your product. I have experience building prototypes, MVPs, and full-scale web applications blazingly fast.",
      icon: "fas fa-desktop",
    },
    {
      name: "Technology Migration",
      desc: "I perform a complete product analysis considering technical, business, and usability aspects. Based on my findings, I draft viable migration solutions and re-engineer the product accordingly.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Rescue Mission",
      desc: "If your last development team left things messy and unfinished, I'm ready to pick up the pieces and help your project get back on track.",
      icon: "fas fa-paint-brush",
    },
    {
      name: "Product Development & Enhancements",
      desc: "I've been enabling businesses to reach out to their customers on all touch points, including web, social, and mobile. Whether you're starting a new project or enhancing an existing one, I can help you achieve your goals.",
      icon: "fas fa-chart-area",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
